/**
 * True ONLY inside the native Capacitor app (the Android/iOS shell), false in
 * every regular browser — including the same production site opened in a mobile
 * browser. Reads the global that Capacitor injects into its WebView, so no
 * `@capacitor/core` import is needed and the web bundle stays unaffected.
 *
 * Use to hide capabilities that don't work in the mobile shell (e.g. screen
 * share) without touching the desktop/web experience.
 */
export function isNativeApp(): boolean {
  if (typeof window === 'undefined') return false;
  const cap = (window as Window & { Capacitor?: { isNativePlatform?: () => boolean } }).Capacitor;
  return cap?.isNativePlatform?.() === true;
}
